import _useMediaQuery from "@material-ui/core/esm/useMediaQuery";
import React, { useState } from 'react';
import classnames from 'classnames';
import { Buttons } from '../buttons';
import cssBase from '../../collect-sizes-popup.scss';
import { getPlaceholder, TEXT, validateName } from '../../collect-sizes.utils';
export const CollectionNameDialog = ({
  isGreetingsStepSkipped,
  isLimitedEdition,
  onNext,
  onBack
}) => {
  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const isMobileView = _useMediaQuery('only screen and (max-width: 767px)');
  const isNextButtonDisabled = Boolean(!name || errorMessage);
  const handleChange = name => {
    setErrorMessage(validateName(name));
    setName(name);
  };
  const handleNext = () => {
    const error = validateName(name);
    if (error) {
      setErrorMessage(error);
    } else {
      onNext(name);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: classnames(cssBase.header, {
      [cssBase.headerLE]: isLimitedEdition
    })
  }, "Amazing, let\u2019s name your size collection link!"), /*#__PURE__*/React.createElement("p", {
    className: cssBase.text
  }, TEXT), /*#__PURE__*/React.createElement("div", {
    className: cssBase.inputWrapper
  }, /*#__PURE__*/React.createElement("input", {
    "data-input": "CollectionName",
    value: name,
    placeholder: getPlaceholder(isMobileView),
    onChange: e => handleChange(e.target.value)
  })), /*#__PURE__*/React.createElement("div", {
    className: cssBase.error
  }, errorMessage), /*#__PURE__*/React.createElement(Buttons, {
    isButtonResponsive: true,
    nextButtonDisabled: isNextButtonDisabled,
    onNextButton: handleNext,
    onBackButton: isGreetingsStepSkipped ? undefined : onBack
  }));
};